import React, { useState, useEffect } from "react";
import { Row, Col, Tag, Divider, Card } from "antd";
// import { CloseOutlined, PlusCircleFilled } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { voucherDateSelector } from "../../../../store/voucher/voucher.selector";
import { snapVoucherByBranchAndDate } from "../../../../store/voucher/voucher.action";
import { unSnapVoucherByDate } from "../../../../store/voucher/voucher.action";
import { labelDateSelector } from "../../../../store/var/var.selector";
import { detailBranchSelector } from "../../../../store/branch/branch.selector";
import { formatNumber } from "../../../../store/utils/format_number/format_number";
import lodash from "lodash";
import { descriptions, renderDescription } from "./string";

const VoucherSoldList = () => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const branch = useSelector(detailBranchSelector);
  const label = useSelector(labelDateSelector);
  const data = useSelector(voucherDateSelector);

  // -------------------------- FUNCTION --------------------------

  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    if (branch && label) {
      dispatch(snapVoucherByBranchAndDate({ date: label, branch: branch?.id }));
    }

    return () => dispatch(unSnapVoucherByDate());
  }, [dispatch, branch, label]);
  // -------------------------- RENDER --------------------------

  const renderList = () => {
    if (!data || data?.length === 0) {
      return <Row style={{ width: "100%" }}>No Voucher Sold</Row>;
    }

    return (
      <Row style={{ width: "100%" }}>
        {data?.map((item, index) => {
          const code = item?.code;
          const balance = item?.balance;
          const spent = item?.spent || 0;
          const sum = balance + spent;
          const labelValue = formatNumber(sum);

          return (
            <Row key={index} style={{ width: "100%", margin: "6px 0px" }}>
              <Col span={14}>
                <Tag>{code}</Tag>
              </Col>
              <Col align="right" span={10}>
                ${labelValue}
              </Col>
            </Row>
          );
        })}
      </Row>
    );
  };

  const renderTotal = () => {
    const finalBalance = lodash?.sumBy(data, (d) => d?.balance);
    const finalSpent = lodash?.sumBy(data, (d) => d?.spent) || 0;
    const finalValue = finalBalance + finalSpent;
    const labelFinal = formatNumber(finalValue);
    return labelFinal;
  };
  // -------------------------- MAIN --------------------------
  const title = (
    <Row style={{ width: "100%" }}>
      <Col span={14}>Voucher Sold: {renderDescription(descriptions.voucherSold)}</Col>
      <Col align="right" span={10}>
        ${renderTotal()}
      </Col>
    </Row>
  );
  return (
    <Row span={24} style={{ width: "100%" }}>
      <Col span={24}>
        <Card className="item-card" title={title}>
          <Col span={24}>{renderList()}</Col>
        </Card>
      </Col>
    </Row>
  );
};

export default VoucherSoldList;
